export default [
    {
        path: '/containers',
        name: 'Containers',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Containers',
        },
        components: {
            default: () => import('@views/containers/ContainerIndex.vue'),
        },
    },
    {
        path: '/containers/create',
        name: 'ContainerCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Create container',
        },
        components: {
            default: () => import('@views/containers/ContainerCreate.vue'),
        },
    },
    {
        path: '/containers/:id/edit',
        name: 'ContainerEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Edit container',
        },
        components: {
            default: () => import('@views/containers/ContainerEdit.vue'),
        },
    },
];
